<script>
import EventBus from './EventBus.js'
export default {
  methods: {
    showNotificationWithMessage (params) {
      this.showNotification(params.icon, params.title, params.text, params.url, params.fixed)
    },
    showNotification (icon, title, text, url, fixed) {
      EventBus.$emit('add-notification', { icon, title, text, url, fixed })
    },
    hideToast () {
      EventBus.$emit('hide-notification')
    }
  }
}
</script>
